/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { Modal } from 'antd-mobile'
// icon
import { ChangeBtnIco } from '@shared/Icon/EtcIcon'
import { Button, ButtonWrap, CloseBtn, ModalFooterWrap, PopupBtnStyle, } from '@styles/button.style'
import useRootStore from '@store/useRootStore'
import MyItem from '@views/MyItem'
import { VIEW_TYPE } from '@constants/index'
import { UserItem } from '@store/userStore'
import { ModalContents, ModalBg } from '@styles/base.style'
import { ModalBodyWarp } from '@views/Popup/MessageContentPopup/index.style'

interface GiftSelectorProps {
  visible: boolean
  setVisible: (arg: boolean) => void
  setSelectedUserItemToParent: (item: UserItem, itemCount: number) => void
}

const GiftSelector: React.FC<GiftSelectorProps> = (props: GiftSelectorProps) => {
  const { visible, setVisible, setSelectedUserItemToParent } = props
  const { globalStore } = useRootStore()
  const [selectedUserItem, setSelectedUserItem] = useState<UserItem>(null)
  const [selectedUserItemCount, setSelectedUserItemCount] = useState(0)
  const [disabledSelectButton, setDisabledSelectButton] = useState(true)

  const onClickCloseButtonHandler = () => {
    if (selectedUserItem) {
      setSelectedUserItem(null)
    }
    setVisible(false)
  }

  const onClickSelectItemHandler = async () => {
    if (selectedUserItem && selectedUserItemCount > 0) {
      setSelectedUserItemToParent(selectedUserItem, selectedUserItemCount)
      onClickCloseButtonHandler()
    } else {
      // 더 이상 사용하지 않는 다이얼로그
      globalStore.pushDialogOk({ text: ['선택된 아이템이 없습니다.'], className: 'small-size' })
    }
  }

  const setSelectedUserItemToParentHandler = (selectedItem: UserItem, selectedItemCount: number): void => {
    setSelectedUserItem(selectedItem)
    setSelectedUserItemCount(selectedItemCount)
  }

  useEffect(() => {
    if (selectedUserItem) {
      setDisabledSelectButton(false)
    }
  }, [selectedUserItem])

  const skinPropertyIds = []
  return (
    <Fragment>
      <Modal
        popup
        maskClosable={false}
        onClose={onClickCloseButtonHandler}
        visible={visible}
        animated={isMobile}
        animationType="slide-up"
        title={
          <Fragment>
            <h1 className="title">아이템 목록</h1>
            <Button onClick={onClickCloseButtonHandler} className="close-btn" css={CloseBtn}>
              <span className="close-txt">닫기</span>
            </Button>
          </Fragment>
        }
        className="full-modal"
      >
        <ModalContents>
          <ModalBodyWarp>
            <MyItem
              propertyIds={skinPropertyIds}
              viewType={VIEW_TYPE.GIF_SELECTOR}
              setSelectedUserItemToParent={setSelectedUserItemToParentHandler} />
          </ModalBodyWarp>
          <ModalFooterWrap css={{ position: 'absolute' }}>
            <ButtonWrap>
              <Button
                css={PopupBtnStyle}
                onClick={onClickCloseButtonHandler}
                className="two-button cancel bottom-btn modal">
                취소
              </Button>
              <Button
                primary
                disabled={disabledSelectButton}
                onClick={onClickSelectItemHandler}
                css={PopupBtnStyle}
                className="two-button bottom-btn modal">
                <ChangeBtnIco />선택
              </Button>
            </ButtonWrap>
          </ModalFooterWrap>
        </ModalContents>

        <ModalBg onClick={onClickCloseButtonHandler} />
      </Modal>
    </Fragment>
  )
}

// 더이상 사용하지 않는 풀팝업
export default observer(GiftSelector)
